import React from 'react'

export default function ContactSpontanContent() {
  return (
    <>
      {/* Content will be added here */}
    </>
  )
}

